import React, { useState, useEffect } from 'react';
import API from '../../api';
import EmployeeList from './EmployeeList';
import ChatBox from './ChatBox';

export default function Chat({ user }) {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [notifications, setNotifications] = useState({});

  // Fetch employees on mount (excluding self)
  useEffect(() => {
    if (!user) return;
    API.get('/chat/employees')
      .then(res => {
        const empArray = Array.isArray(res.data) ? res.data : res.data.employees || [];
        const filtered = empArray.filter(emp => emp.id !== Number(user.id));
        setEmployees(filtered);
      })
      .catch(err => console.error('Failed to fetch employees:', err));
  }, [user]);

  // Fetch messages when selectedEmployee changes
  useEffect(() => {
    if (!selectedEmployee) return;
    fetchMessages();
    clearNotification(selectedEmployee.id);
  }, [selectedEmployee]);

  const fetchMessages = async () => {
    try {
      const res = await API.get('/chat', {
        params: { with: selectedEmployee.id }
      });
      setMessages(res.data);
    } catch (error) {
      console.error('Failed to fetch messages:', error);
    }
  };

  // Poll for notifications
  useEffect(() => {
    const interval = setInterval(() => {
      API.get('/chat/unread')
        .then(res => setNotifications(res.data))
        .catch(err => console.error('Failed to fetch notifications:', err));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const clearNotification = (employeeId) => {
    setNotifications(prev => {
      const updated = { ...prev };
      delete updated[employeeId];
      return updated;
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage && !imageFile) return;

    const formData = new FormData();
    formData.append('receiver_id', selectedEmployee.id);
    formData.append('message', newMessage);
    if (imageFile) formData.append('image', imageFile);

    try {
      await API.post('/chat', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setNewMessage('');
      setImageFile(null);
      fetchMessages();
    } catch (error) {
      console.error('Send message error:', error);
    }
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      await API.delete(`/chat/delete/${messageId}`);
      setMessages(prev => prev.filter(msg => msg.id !== messageId));
    } catch (err) {
      console.error('Failed to delete message:', err);
    }
  };

  return (
    <div className="flex h-full w-full ml-auto bg-white rounded shadow-lg overflow-hidden">
      <EmployeeList
        employees={employees}
        selectedEmployee={selectedEmployee}
        onSelect={setSelectedEmployee}
        notifications={notifications}
      />
      <ChatBox
        selectedEmployee={selectedEmployee}
        messages={messages}
        newMessage={newMessage}
        setNewMessage={setNewMessage}
        imageFile={imageFile}
        setImageFile={setImageFile}
        onSendMessage={handleSendMessage}
        onDeleteMessage={handleDeleteMessage}
        currentUser={user}
      />
    </div>
  );
}
